import { createStore } from 'vuex';
import systemInfo from './modules/systemInfoStore';
import gmxCommon from './modules/gmxCommonStore';
import gmxMain from './modules/gmxMainStore';
import versionStore from './modules/versionStore';
import sseStore from './modules/sseStore';

const store = createStore({
  modules: {
    systemInfo,
    gmxCommon,
    gmxMain,
    versionStore,
    sse: sseStore
  }
})

export default store;
